<template>
  <v-col>
    <v-autocomplete
      :items="trainTypes"
      :rules="[required]"
      outlined
      label="Tågtyp"
      v-model="type"
    />
  </v-col>
</template>

<script>
import { sync } from 'vuex-pathify'
import trainTypes from '@/common/trainTypes'
import { required } from '@/common/validationRules'

export default {
  name: 'RejectedStopTypeField',

  data: () => ({
    required,
    trainTypes
  }),

  computed: {
    type: sync('rejectedStop/model@type')
  }
}
</script>
